<template>
  <div class="list-container">
    <!--    List-->
    <div class="terms-container">
      <div class="agreement-content">
        {{ `Message List` }}
      </div>
      <div class="agreement-title">
        {{ 'Title' }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  computed,
  inject,
  markRaw,
  onMounted,
  onUnmounted,
  ref,
  watch
} from 'vue';
import router from '@/router';
import { useRoute } from 'vue-router';
import { channelMethods, postToApp } from '@/utils/channelMethod';
import { formatDateTime, getCookie, getCredential, getKey } from '@/utils';
import { officialAddress, email, website } from '@/utils/orderConfig';
import { showToast } from 'vant';
import SubmitButton from '@/views/custom/SumbitButton.vue';

export default {
  name: 'messagePage',
  components: { SubmitButton },
  methods: { addressL: officialAddress, emailL: email, miWebsite: website, formatDateTime },
  setup() {
    const loading = ref(false);
    const timer = ref();
    const route = useRoute();
    const countdown = ref(3);
    const resultFrag = ref(false);

    const tag = computed(() => {
      return route.query.tag;
    });

    const isSuccess = computed(() => {
      return route.query.tag == '1';
    });

    const resultContent = computed(() => {
      return isSuccess.value ? 'Success!' : 'Failed';
    });

    const startCountdown = () => {
      if (timer.value) {
        clearInterval(timer.value);
      }

      timer.value = setInterval(() => {
        if (countdown.value > 0) {
          countdown.value--;
        } else {
          costResult();
        }
      }, 1000);
    };

    const handleBackClick = () => {
      costResult();
    };

    const costResult = () => {
      if (!resultFrag.value) {
        resultFrag.value = true;
        if (timer.value) {
          clearInterval(timer.value);
        }
        postToApp(channelMethods.getResult, tag.value);
      }
    };

    onMounted(() => {
      document.title = '';
      // postToApp(channelMethods.darkMode, 'default');
      startCountdown();
    });

    onUnmounted(() => {
      if (timer.value) {
        clearInterval(timer.value);
      }
    });

    return {
      loading,
      countdown,
      resultContent,
      handleBackClick,
      isSuccess
    };
  }
};
</script>

<style lang="scss" scoped>
.list-container {
  width: 100vw;
  height: 100vh;
  background-color: #ffffff;
  max-width: $max-width;
  position: relative;

  display: flex;
  flex-direction: column;

  .list-body {
    flex: 1;

    margin: 179px 60px 25px;

    overflow-y: auto;
    overflow-x: hidden;

    display: flex;
    flex-direction: column;
    align-items: center;

    .count-item {
      font-weight: 600;
      font-size: 32px;
      color: #333333;
      line-height: 40px;
      text-align: center;
      font-style: normal;

      width: 100%;
      display: flex;
      justify-content: end;
    }

    .result-icon {
      margin-top: 42px;

      width: 230px;
      height: 238px;
    }

    .result-content {
      margin-top: 50px;

      font-weight: 600;
      font-size: 32px;
      color: #333333;
      line-height: 40px;
      text-align: center;
      font-style: normal;
    }

    .result-action {
      margin-top: 80px;
      width: 100%;
    }
  }
}
</style>